<template>
	<div v-if="stats">
		<template v-for="(sts, stat_type) in srt_stats">
			<div class="stat-type">{{stat_type}}:</div>
			<template v-for="(st,channel_name) in sts">
				<k-layout class="ks-font-size-s">
					<k-flex c1>
						<k-btn no-margin size="xs" icon :icon-name="get_show_icon_name(channel_name)" @click="toggle_show_info(channel_name)"></k-btn>
      			<k-icon :color="get_icon_color(st.connected)" small>circle</k-icon>
					</k-flex>
					<k-flex c4>
						<channel-title :channel="get_channel(channel_name)" :alternative="get_alternative(channel_name)"></channel-title>
					</k-flex>
					<k-flex c4>
						{{get_headend_name(st.headend)}} ({{get_headend_port(st.headend)}})
					</k-flex>
					<k-flex c3>
						{{st.peer}}
					</k-flex>

<!--					<k-flex c2>
						{{st.connected}}
					</k-flex>-->
				</k-layout>
				<div v-if="show_info[channel_name]">  
				<!-- FIXME: Nämä avattavaksi-->
					<srt-stats :stats="st.stats" type="recv"></srt-stats>
				</div>
			</template>
		</template>
	</div>
</template>

<script>

import datelib from '@/lib/date.js';
import moment from 'moment';
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js'
import ChannelTitle from '@/components/ChannelTitle.vue';
import SrtStats from '@/components/stats/Srt.vue';
import Vue from 'vue';


export default {
  props: ["id", "stats"],
  components: {
  	ChannelTitle,
  	SrtStats
  },
  data () {
  	return {
  		show_info: {}
  	}
  },
  methods: {
  	get_icon_color(state) {
  		if (state == true) return "success";
  		return "primary";
  	},
  	get_show_icon_name(channel_name) {
  		if (this.show_info[channel_name]) return "keyboard_arrow_down";
			return "keyboard_arrow_right";
  	},
  	toggle_show_info(channel_name) {
  		Vue.set(this.show_info, channel_name, !this.show_info[channel_name]);
  	},
  	get_channel(channel_name) {
  		return ChannelModel.channel_by_name(channel_name);
  	},
  	get_alternative(channel_name) {
  		if (channel_name.includes(":")) return channel_name.split(":")[1];
			return "";		
  	},
  	get_headend_name(headend_ip) {
			var instances = InstanceModel.instances_by_type("headend",false);
			var headend_ip = headend_ip.split(":")[0];
			var headend = _.find(instances, function(instance) {
				if (instance.system_info.ip == headend_ip) return true;
				return false;
			})

			return InstanceModel.title(headend);
  	},
  	get_headend_port(headend_ip) {
  		return headend_ip.split(":")[1];
  	}
  },
  computed: {
  	srt_stats() {
  		if (typeof(this.stats) == "undefined") return {};
  		if (typeof(this.stats.srt_stats) == "undefined") return {};
  		return this.stats.srt_stats;
  	}
  }
}
</script>
<style scoped>
	.stat-type {
		color: var(--ks-font-color-title);
		text-transform: capitalize;
	}
</style>